import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { DxDataGridModule } from "devextreme-angular";
import { PanelsModule } from "src/app/shared/panels/panels.module";
import { FocusingModule } from "src/app/shared/ui/forms/inputs/focusing.module";
import { Select2Module } from "src/app/shared/ui/forms/inputs/oops-select2/select2.module";
import { StatusColorModule } from "src/app/shared/ui/forms/inputs/status-color/status-color.module";

import { PriceDimensionsComponent } from "./price-dimensions.component";
import { ConditionComponent } from "./search/condition/condition.component";
import { ResultComponent } from "./search/result/result.component";
import { SearchConverter, DetailsConverter } from "./shared";
import { DaterangepickerModule } from "src/app/shared/ui/forms/inputs/oops-daterangepicker/daterangepicker.module";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ItemsFoundModule } from "src/app/core/pipes/items-found/items-found.module";
import { MatIconModule } from "@angular/material/icon";
import { UiModule } from "src/app/shared/ui/ui.module";

@NgModule({
    imports: [
        BsDropdownModule,
        CommonModule,
        DaterangepickerModule,
        DxDataGridModule,
        FocusingModule,
        ItemsFoundModule,
        MatIconModule,
        PanelsModule,
        ReactiveFormsModule,
        StatusColorModule,
        Select2Module,
        UiModule
    ],
    declarations: [ 
       PriceDimensionsComponent,
       ConditionComponent,
       ResultComponent,
    ],
    exports : [
        PriceDimensionsComponent
    ],
    providers : [
        SearchConverter,
        DetailsConverter
    ]
})

export class PriceDimensionsModule { }